import { Phone } from "lucide-react";
import { PHONE_TEL } from "../data/content";

export const StickyCallButton = () => (
  <a
    data-testid="sticky-call-button"
    href={PHONE_TEL}
    aria-label="Call Mason's Mobile Mechanic now"
    className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full px-5 py-4 font-semibold shadow-2xl pulse-call transition-colors"
  >
    <Phone className="h-5 w-5" />
    <span className="hidden sm:inline">Call Now</span>
  </a>
);
